<template>
  <VueApexCharts
    type="bar"
    height="350"
    :options="barChart.chartOptions"
    :series="barChart.series"
  />
</template>

<script>
import VueApexCharts from "vue-apexcharts";
export default {
  components: { VueApexCharts },
  data() {
    return {
      barChart: {
        series: [
          {
            data: [106, 32, 16, 8, 4],
          },
        ],
        chartOptions: {
          colors: ["#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"],
          plotOptions: {
            bar: {
              horizontal: true,
            },
          },
          dataLabels: {
            enabled: true,
          },
          xaxis: {
            categories: [
              "Pasar Malam",
              "Pasar Pagi",
              "Pasar Tani",
              "Pasar Minggu",
              "Pasar Tamu",
            ],
          },
        },
      },
    };
  },
};
</script>
